import { render } from "./CompareBoat.vue?vue&type=template&id=00a00b94&scoped=true"
import script from "./CompareBoat.vue?vue&type=script&lang=js"
export * from "./CompareBoat.vue?vue&type=script&lang=js"

import "./CompareBoat.vue?vue&type=style&index=0&id=00a00b94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a00b94"]])

export default __exports__